<template>
    <div>
        <div>
            <b-card v-show="mostrarForm" no-body>
                <b-card-header>
                    <span class="h5">
                        FILIAIS -
                        <b-badge variant="warning">{{ operacao }}</b-badge>
                    </span>
                </b-card-header>
                <b-card-body>
                    <div>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                    </div>
                    <div class="ml-2">
                        <b-row>
                            <b-col sm="12" md="3">
                                <b-form-group>
                                    <label class="required">
                                        CNPJ/CPF da matriz
                                    </label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            placeholder="Digite o CNPJ/CPF"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                                            v-model="cnpjCpfMatriz"
                                            @input.native="$v.cnpjCpfMatriz.$touch()"
                                            :state="$v.cnpjCpfMatriz.$error ? false : null"
                                        ></b-form-input>
                                        <b-form-invalid-feedback
                                            >O CPF ou CNPJ está invalido
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3">
                                <b-form-group>
                                    <label class="required">
                                        CNPJ/CPF da filial
                                    </label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            placeholder="Digite o CNPJ/CPF"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                                            v-model="cnpjCpfFilial"
                                            @input.native="$v.cnpjCpfFilial.$touch()"
                                            :state="$v.cnpjCpfFilial.$error ? false : null"
                                        ></b-form-input>
                                        <b-form-invalid-feedback
                                            >O CPF ou CNPJ está invalido
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </b-card-body>
                <b-card-footer>
                    <app-btn-voltar></app-btn-voltar>
                    <b-button
                        class="float-right"
                        variant="success"
                        @click.stop="confirmarSalvar()"
                        :disabled="!habilitarSalvar"
                        v-if="$temAcessoView('ADMIN-FILIAIS-01')"
                    >
                        <span> <i class="fa fa-check"></i> Concluir </span>
                    </b-button>
                </b-card-footer>
            </b-card>
        </div>
        <router-view></router-view>
    </div>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FiliaisServicos from './FiliaisServicos'

export default {
    data() {
        return{
            cnpjCpfMatriz: null,
            cnpjCpfFilial: null,
            erros: [],
            operacao: 'INSERIR'
        }
    },

    methods: {
        obterFilial() {
            this.$store.dispatch('addRequest')
            FiliaisServicos.obterPorId(this.$route.params.filialId).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherForm(response.data)
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                        this.$emit('obterFiliais')
                        this.$router.push({ name: 'Filiais' })
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherForm(filial) {
            this.cnpjCpfMatriz = filial.cnpjCpfMatriz
            this.cnpjCpfFilial = filial.cnpjCpfFilial
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Relação de Filial',
                html: `Confirma a ${this.operacao == 'INSERIR' ? 'inserção': 'atualização'} da relação entre a matriz 
                    <strong>${this.cnpjCpfMatriz}</strong> e a filial <strong>${this.cnpjCpfFilial}</strong>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            if (this.operacao == 'INSERIR') {
                this.inserir()
            } else {
                this.atualizar()
            }
        },

        inserir() {
            let filialDto = {
                cnpjCpfMatriz: this.cnpjCpfMatriz.replace(/\D+/g, ''),
                cnpjCpfFilial: this.cnpjCpfFilial.replace(/\D+/g, '')
            }
            this.$store.dispatch('addRequest')
            FiliaisServicos.inserir(filialDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizar() {
            let filialDto = {
                filialId: this.$route.params.filialId,
                cnpjCpfMatriz: this.cnpjCpfMatriz.replace(/\D+/g, ''),
                cnpjCpfFilial: this.cnpjCpfFilial.replace(/\D+/g, '')
            }
            this.$store.dispatch('addRequest')
            FiliaisServicos.atualizar(filialDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                `Registro ${this.operacao == 'INSERIR' ? 'inserido': 'atualizado'} com sucesso!`,
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterFiliais')
            this.$router.push({ name: 'Filiais' })
        },

        validaTamanhoCpfCnpj(cnpjcpf) {
            return (
                cnpjcpf.length == '14' ||
                cnpjcpf.length == '18'
            )
        }
    },

    validations: {
        cnpjCpfMatriz: {
            required,
            validaCpfCnpj() {
                return this.validaTamanhoCpfCnpj(this.cnpjCpfMatriz)
            }            
        },
        cnpjCpfFilial: {
            required,
            validaCpfCnpj() {
                return this.validaTamanhoCpfCnpj(this.cnpjCpfFilial)
            }            
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        mostrarForm() {
            return ( this.$route.name === 'Filiais_Inserir_Filial' 
                || this.$route.name === 'Filiais_Atualizar_Filial' )
        },
    },   

    created() {
        this.operacao = this.$route.params.operacao
    },

    watch: {
        operacao() {
            if (this.operacao == 'ATUALIZAR') {
                this.obterFilial()
            }
        },
    }
}

</script>